import AddCommitteeButton from './AddCommitteeButton';
import AddCommitteeDrawer from './AddCommitteeDrawer';
import { Star } from 'lucide-react';
import { useState } from 'react';

const CommitteeTitle = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  return (
    <div className="flex justify-between items-start mb-8">
      <div>
        <div className="flex text-sm text-slate-400 mb-2">
          <h1 className="page-title font-bold text-slate-800">Board & Committees</h1>

          <Star size={20} className="text-slate-400 mt-2 ml-2" />
        </div>

        <div className="flex items-center page-title-container">
          <span className="text-slate-500">Governance</span>
          <span>{'>'}</span>
          <span className="text-slate-600 font-medium">Board & Committees</span>
        </div>

        <p className="text-slate-500 ">Oversee governance bodies, meetings, decisions and external approvals.</p>
      </div>

      <AddCommitteeButton onClick={() => setIsDrawerOpen(true)} />

      <AddCommitteeDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
    </div>
  );
};

export default CommitteeTitle;
